<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col class="pt-10 text-center" cols="3">
            <v-avatar size="200" max-height="100%" max-width="100%">
              <img
                alt="user"
                :src="
                  user.profilePicUrl
                    ? user.profilePicUrl
                    : '/img/No_Image_Available.jpg'
                "
              />
              <v-file-input
                id="fileUpload"
                accept="image/*"
                hide-input
                @change="onFileChanged"
                prepend-icon=""
              />
            </v-avatar>
            <v-btn
              style="position: absolute; bottom: 20%; left: 17%"
              depressed
              color="primary"
              fab
              @click="getFile"
            >
              <v-icon>mdi-camera-account</v-icon>
            </v-btn>
            <div v-if="currentImage" class="progress">
              <div
                class="progress-bar progress-bar-info"
                role="progressbar"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: progress + '%' }"
              >
                {{ progress }}%
              </div>
            </div>
          </v-col>

          <v-col cols="9">
            <v-form
              ref="profile_form"
              v-model="valid"
              lazy-validation
              @submit.prevent="updateProfile"
            >
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="6" sm="6">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{ $t("First Name") }}</label
                      >
                      <v-text-field
                        v-model="user.firstName"
                        outlined
                        dense
                        :rules="rules.firstName"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{ $t("Last Name") }}</label
                      >
                      <v-text-field
                        v-model="user.lastName"
                        outlined
                        dense
                        :rules="rules.lastName"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="mt-n8">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{ $t("Email ID") }}</label
                      >
                      <v-text-field
                        v-model="user.email"
                        outlined
                        dense
                        :rules="rules.email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="mt-n8">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{ $t("Mobile Number") }}</label
                      >
                      <v-row no-gutters class="d-flex">
                        <v-col cols="3">
                          <v-autocomplete
                            style="background-color: #1f5d51"
                            outlined
                            :items="countries"
                            item-value="MobileCode"
                            class="phone-drop rounded-r-0 outline-l-0"
                            v-model="user.countryCode"
                            dense
                            ref="phoneSelect"
                            hide-details
                            :rules="rules.countryCode"
                          >
                            <template v-slot:item="slotProps">
                              <i
                                :class="[
                                  'mr-2',
                                  'em',
                                  `em-flag-${slotProps.item.Code.toLowerCase()}`,
                                ]"
                              ></i>
                              &nbsp;
                              {{
                                ` (+${slotProps.item.MobileCode}) ${slotProps.item.Name}`
                              }}
                            </template>
                            <div
                              class="truncate"
                              slot="selection"
                              slot-scope="data"
                              style="
                                color: white;
                                font-size: 12px;
                                font-weight: bold;
                              "
                            >
                              <span>
                                <!-- <i :class="['em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>&nbsp; -->
                                {{ `( +${data.item.MobileCode} )` }}
                              </span>
                            </div>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field
                            v-model="user.mobile"
                            outlined
                            dense
                            :rules="rules.mobile"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <!-- <v-col cols="12" sm="6" class="mt-n8">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{$t('role')}}</label
                      >
                      <v-text-field
                        v-model="user.role"
                        outlined
                        disabled
                        dense
                      ></v-text-field>
                    </v-col> -->
                    <!-- <v-col cols="12" sm="6" class="mt-n8">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="note"
                        >{{$t('department')}}</label
                      >
                      <v-text-field
                        v-model="user.department"
                        outlined
                        disabled
                        dense
                      ></v-text-field>
                    </v-col> -->
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="goBack"
                      right
                      height="44"
                      width="116"
                      color="primary"
                      outlined
                    >
                      {{ $t("cancel") }}
                    </v-btn>
                    <v-btn
                      type="submit"
                      right
                      height="44"
                      width="116"
                      color="primary"
                    >
                      {{ $t("update") }}
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showVerifyOTPCard" width="609">
      <v-toolbar color="secondary" class="white--text">
        <v-toolbar-title class="font-weight-bold"
          >OTP Verification</v-toolbar-title
        >

        <v-spacer></v-spacer>

        <v-btn icon class="white--text" @click="cancelAction">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="py-12 px-10">
        <div class="text-center text-h4 font-weight-black">
          One-Time Password (OTP) Verification
        </div>
        <v-card-text class="text-center flex-direction-box">
          <div class="vertical-center black--text">
            <h2 class="font-weight-black py-8 title">Enter 6 digits Code</h2>
            <p class="subtitle">
              Enter the 6 digits code that you received on your email or mobile
              number.
            </p>
            <div class="ma-auto position-relative" style="max-width: 300px">
              <v-otp-input v-model="otp" length="6" plain></v-otp-input>
            </div>
            <p class="body-1 mt-10">
              Didn't receive OTP?
              <v-btn
                @click="sendOTP"
                color="primary"
                class="body-1 px-0 pb-1 btn"
                plain
                depressed
              >
                Resend OTP</v-btn
              >
              .
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="cancelAction" outlined> Cancel </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="verifyOTP" :disabled="!isOTPActive">
            VERIFY
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Error </v-card-title>

        <v-card-text>
          {{ errorText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey darken-1" text @click="errorDialog = false">
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import UserService from "@/_services/UserService";
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import ProfileService from "../../_services/ProfileService";
import countries from "@/constants/countries.js";

export default {
  created() {
    this.getProfileData();
  },
  computed: {
    profileChange() {
      return (
        this.user.firstName == this.orgUser.firstName &&
        this.user.lastName == this.orgUser.lastName &&
        this.user.email == this.orgUser.email &&
        this.user.mobile == this.orgUser.mobile &&
        this.user.countryCode == this.orgUser.countryCode &&
        this.user.countryCode
      );
    },
    isOTPActive() {
      return this.otp.length === 6;
    },
  },
  data() {
    return {
      countries,
      valid: true,
      isSelecting: false,
      selectedFile: null,
      errorDialog: false,
      showVerifyOTPCard: false,
      otp: "",
      payload: {},
      errorText: "",
      orgUser: {},
      currentImage: undefined,
      progress: 0,
      imageInfos: [],
      user: {
        countryCode: "",
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        profilePicUrl: "",
        role: "",
        userName: "",
        imgURL: "",
      },
      rules: {
        firstName: [
          (v) => !!v || "Firstname is required.",
          (v) => this.onlyAlpha(v) || "Can only contain alphabets",
          (v) => (v && v.length <= 15) || "Can't be more then 15 characters",
        ],
        lastName: [
          (v) => !!v || "Lastname is required.",
          (v) => this.onlyAlpha(v) || "Can only contain alphabets",
          (v) => (v && v.length <= 15) || "Can't be more then 15 characters",
        ],
        email: [
          (v) =>
            v == "" || this.validateEmail(v) || this.$t("invalidEmailFormat"),
        ],
        mobile: [
          (v) =>
            v?.length == 0 ||
            v?.length >= 8 ||
            "Phone can not be less then 8 chars",
        ],
        countryCode: [(v) => !!v || "Country code is required"],
      },
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: "My farm" });
    },
    getProfileData() {
      this.startLoading();

      ProfileService.getProfileData()
        .then((res) => {
          if (res.success) {
            console.log(res);
            for (var k in res.data) this.user[k] = res.data[k];
            this.orgUser = res.data;
            console.log("get", this.orgUser);
          }
          this.stopLoading();
        })
        .catch((e) => {
          console.log(e);
          this.$router.push("/login");
          this.stopLoading();
        });
    },
    getFile() {
      let fileUpload = document.getElementById("fileUpload");
      if (fileUpload != null) {
        fileUpload.click();
      }
    },
    onFileChanged(filename) {
      this.selectedFile = filename;
      if (this.selectedFile) {
        let size = this.selectedFile.size;
        console.log(size);
        if (!this.selectedFile.type.match("image.*")) {
          // check whether the upload is an image
          this.errorDialog = true;
          this.errorText = this.$t("pleaseChooseAnImageFile");
        } else if (size > 1000000) {
          // check whether the size is greater than the size limit
          this.errorDialog = true;
          this.errorText = this.$t("fileIsTooBigSelectUnder1MB");
        } else {
          // Append file into FormData & turn file into image URL
          let formData = new FormData();
          // let imageURL = URL.createObjectURL(this.selectedFile)
          // console.log("url",imageURL)
          formData.append("profilePic", this.selectedFile);
          this.startLoading();
          ProfileService.imageUpdate(formData)
            .then((res) => {
              if (res.success) {
                this.user.profilePicUrl = res.data.profilePicUrl;
                this.$notify({
                  title: this.$t("Profile Updated"),
                  text: ``,
                  type: "success",
                });
              }
              // this.getProfileData()
              this.stopLoading();
            })
            .catch(() => {
              this.$notify({
                title: this.$t("somethingWentWrong"),
                text: this.$t("pleaseTryAgainAfterSometime"),
                type: "error",
              });
              this.stopLoading();
            });
        }
      }
    },
    updateProfile() {
      if (!this.$refs.profile_form.validate()) return;
      console.log("payload", this.payload);
      if (this.user.email == "" && this.user.mobile == "") {
        this.$notify({
          title: this.$t("Email and Mobile, both can't be empty."),
          text: ``,
          type: "error",
        });
        return;
      }
      if (
        this.user.firstName == this.orgUser.firstName &&
        this.user.lastName == this.orgUser.lastName &&
        this.user.email == this.orgUser.email &&
        this.user.mobile == this.orgUser.mobile &&
        this.user.countryCode == this.orgUser.countryCode
      ) {
        this.$notify({
          title: this.$t("nothingchanged"),
          text: ``,
          type: "error",
        });
        return;
      }
      if (
        this.user.email !== this.orgUser.email ||
        this.user.mobile !== this.orgUser.mobile
      ) {
        this.showVerifyOTPCard = true;
        if (this.user.mobile && this.user.mobile !== this.orgUser.mobile) {
          this.payload.mobile = this.user.mobile;
          this.payload.countryCode = this.user.countryCode;
          this.payload.type = "mobile"; //type: email || mobile
        } else if (this.user.email !== this.orgUser.email) {
          this.payload.email = this.user.email;
          this.payload.type = "email"; //type: email || mobile
          this.payload.firstName = this.orgUser.firstName;
        }
        this.sendOTP();
      } else {
        this.startLoading();
        const { firstName, lastName, email, mobile, countryCode } = this.user;
        ProfileService.updateProfileData({
          firstName,
          lastName,
          email,
          mobile,
          countryCode,
          verificationType: this.payload.type,
        })
          .then((res) => {
            console.log(res);
            this.$notify({
              title: this.$t("user.profileUpdated"),
              text: ``,
              type: "success",
            });
            ProfileService.getProfileData()
              .then((res) => {
                this.$store.commit("updateUserData", res.data);
                this.stopLoading();
              })
              .catch(() => {
                this.$router.push("/login");
                this.stopLoading();
              });
          })
          .catch(() => {
            this.$notify({
              title: this.$t("somethingWentWrong"),
              text: this.$t("pleaseTryAgainAfterSometime"),
              type: "error",
            });
          });
        this.stopLoading();
      }
    },
    sendOTP() {
      UserService.sendOTPProfileUpdate(this.payload)
        .then((res) => {
          console.log({ res });
          if (res.code == 200 && res.success == true) {
            this.$notify({
              title: res.message,
              type: "success",
            });
          } else {
            this.showVerifyOTPCard = false;
            throw new Error(res.message);
          }
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            title: err.message,
            type: "error",
          });
          this.stopLoading();
        });
    },
    verifyOTP() {
      this.startLoading();
      UserService.verifyOTPProfileUpdate({
        credential:
          this.payload.type == "email"
            ? this.user.email
            : `+${this.user.countryCode}${this.user.mobile}`,
        otp: this.otp,
        type: this.payload.type,
      })
        .then((res) => {
          if (res.code == 200 && res.success == true) {
            this.dialog = true;
            this.startLoading();
            const { firstName, lastName, email, mobile, countryCode } =
              this.user;
            ProfileService.updateProfileData({
              firstName,
              lastName,
              email,
              mobile,
              countryCode,
              verificationType: this.payload.type,
            })
              .then((res) => {
                console.log(res);
                this.$notify({
                  title: this.$t("user.profileUpdated"),
                  text: ``,
                  type: "success",
                });
                this.showVerifyOTPCard = false;
                ProfileService.getProfileData()
                  .then((res) => {
                    this.$store.commit("updateUserData", res.data);
                    this.stopLoading();
                  })
                  .catch((e) => {
                    console.log(e);
                    this.$router.push("/login");
                    this.stopLoading();
                  });
              })
              .catch(() => {
                this.$notify({
                  title: this.$t("somethingWentWrong"),
                  text: this.$t("pleaseTryAgainAfterSometime"),
                  type: "error",
                });
              });
          } else {
            throw new Error("Incorrect OTP.");
          }
          this.stopLoading();
        })
        .catch(() => {
          this.$notify({
            title: "Incorrect OTP",
            type: "error",
          });
          this.stopLoading();
        });
      this.payload = {};
      this.stopLoading();
    },
    cancelAction() {
      this.showVerifyOTPCard = false;
      this.payload = {};
      this.otp = "";
    },
  },
  mixins: [loading, generalMixin],
};
</script>
